import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CommonService } from '../../../services/common/common.service';
import { ValidationService } from '../../../services/validation/validation.service';
import { ToastService } from '../../../services/toast.service';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { lastValueFrom } from 'rxjs';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrl: './change-password.component.scss'
})
export class ChangePasswordComponent implements OnInit {
  constructor(private fb: FormBuilder, private commonService: CommonService,
    private validationService: ValidationService, private toast: ToastService,
    private router: Router, private location: Location,
    private modalService: NgbModal,
  ) { }

  passwordForm!: FormGroup;
  passwordFieldType: string = 'password';
  confirmPasswordFieldType: string = 'password';
  oldPasswordFieldType: string = 'password';
  submit: boolean = false;
  showMessage = false;
  passLength: any = '';
  passwordHint: string = 'Password must contain: one uppercase letter, one lowercase letter, one number, one special character.';
  userData: any = localStorage.getItem('auth_user');
  employeeDetail: any = this.userData ? JSON.parse(this.userData) : '';
  currentComplexity: string[] = [];
  isDefaultPolicy: boolean = false;

  ngOnInit() {
    //console.log(this.employeeDetail);
    this.passwordForm = this.fb.group({
      username: [this.employeeDetail.name, [Validators.required, Validators.maxLength(100)]],
      oldpassword: ['', [Validators.required]],
      newpassword: ['', [Validators.required, Validators.minLength(6), Validators.maxLength(14), Validators.pattern(this.validationService.password),]],
      confirmpassword: ['', [Validators.required,
      this.matchPasswordValidator.bind(this)]]
    })
    this.passwordForm.get('newpassword')?.valueChanges.subscribe(val => {
      this.passwordHint = this.validationService.getMissingRequirementsHint(val, this.currentComplexity, this.isDefaultPolicy);
      this.passwordForm.get('confirmpassword')?.updateValueAndValidity();
    });

    this.setPassword()
  }

  async setPassword() {
    let data: any = this.commonService.getLocalStorageData();
    console.log("-==-data", data);

    if (!data?.client) {
      const companyID = data?.role_type == 'super_user' ? data?.super_user_company_id : data?.companyID;
      console.log("-==-companyID", companyID);

      const params: any = companyID ? await lastValueFrom(this.commonService.getPasswordPolicy(companyID)) : null;

      let policyData = params?.data;
      const roleType = this.employeeDetail?.role_type;
      const isAdmin = roleType === 'admin' || roleType === 'sub_admin' || roleType === 'super_admin';

      if (isAdmin) {
        policyData = null;
      }

      const details = this.validationService.applyPasswordPolicy(
        this.passwordForm.get('newpassword'),
        policyData,
        (hint) => (this.passwordHint = hint)
      );
      if (details) {
        this.passLength = details.minLength;
        this.currentComplexity = details.complexity;
        this.isDefaultPolicy = details.isDefault;
      }
    }
  }

  get form() {
    return this.passwordForm.controls;
  }

  isInvalid(controlName: any): any {
    const control = this.passwordForm.get(controlName);
    return (
      (this.submit && control?.invalid) ||
      (this.submit && !!control?.errors) ||
      (control?.invalid && (control.dirty || control.touched))
    );
  }

  togglePasswordVisibility(name: any) {
    if (name == 'newpassword') {
      this.passwordFieldType =
        this.passwordFieldType === 'password' ? 'text' : 'password';
    } else if (name == 'confirmpassword') {
      this.confirmPasswordFieldType =
        this.confirmPasswordFieldType === 'password' ? 'text' : 'password';
    } else {
      this.oldPasswordFieldType = this.oldPasswordFieldType === 'password' ? 'text' : 'password';
    }
  }

  matchPasswordValidator(control: { value: any }) {
    if (!control.value) {
      return null;
    }
    if (control.value !== this.passwordForm?.get('newpassword')?.value) {
      return { mismatch: true };
    }
    return null;
  }

  formErrors: any = '';
  private updateFormErrors(): void {
    this.formErrors = {};
    Object.keys(this.passwordForm.controls).forEach((field) => {
      const control = this.passwordForm.get(field);
      if (control && control.errors) {
        this.formErrors[field] = control.errors;
      }
    });
  }

  formSubmit() {
    this.submit = true;
    if (this.passwordForm.invalid) {
      //console.log(this.passwordForm.value);
      this.updateFormErrors();
      return;
    }
    //console.log("hello",this.passwordForm.value);

    this.commonService.changePassword(this.passwordForm.value).subscribe({
      next: resp => {
        this.toast.success(resp.message);
        this.router.navigateByUrl('/', { replaceUrl: true });
      },
      error: err => {
        console.log(err.error.message);
        this.toast.failure(err.error.message);
      }
    })
  }

  goToBack() {
    // this.modalService.dismissAll();
    const firstLogin = this.router.url.includes('firstLogin=1');
    if (firstLogin) {
      this.location.back();
    } else {
      this.modalService.dismissAll();
    }
  }

  onCopy(event: ClipboardEvent): void {
    event.preventDefault();
    this.showMessage = true;
    setTimeout(() => {
      this.showMessage = false;
    }, 3000);
  }

  onPaste(event: ClipboardEvent): void {
    event.preventDefault();
    this.showMessage = true;
    setTimeout(() => {
      this.showMessage = false;
    }, 3000);
  }

}
